<template>
  <div class="pages" :style="isShowPageTitle == false ? 'padding: 0' :''">
    <div v-if="isShowPageTitle" class="page-column-name">{{ $route.meta.title }}</div>
    <!-- <div class="pages-content"> -->
      <jd-form
        :form-info="inputInkidNeedAwardList"
        :isreData="true"
        :emitReset="true"
        @search="searchInkind"
        @reset="resetForm"
        ref="export_fun_swRef"
        class="mb16"
      >
        <template slot="active">
          <select-activity
            ref="selectActivityRef"
            :form.sync="activityObj"
            firstLabel="全部"
            :options="activityList"
            :activityTypeDisabled="activityType != ''"
            style="display: inline-block"
          ></select-activity>
        </template>
      </jd-form>
      <div class="flex-spc-x mb12" style="margin-top: 15px">
        <div>
          <jd-button
            @click="batchMarkForShipment"
            :disabled="!inkindTable.length"
            v-preventReClick
            >批量标记发货</jd-button
          >
           <jd-button
            @click="dialogTableVisible = true"
            >按查询结果生成人群</jd-button
          >
        </div>
        <div>
          <jd-button
              type="text"
              @click="exportFn"
              v-preventReClick
              >导出</jd-button
              >
        </div>
      </div>
      <jd-table
        :loading="loading"
        :tableData="inkindTable"
        :pageInfo="{
          pageNum: formList.current,
          pageSize: formList.size,
          total: totalInkind,
        }"
        rowKey="id"
        @handlePage="handlePageInkind"
      >
        <el-table-column
          :prop="chaosParams"
          :label="`用户${grayText}`"
          min-width="150"
        >
        </el-table-column>
        <el-table-column prop="memberNick" label="用户昵称" width="180">
        </el-table-column>
        <el-table-column label="活动类型" min-width="180">
          <template slot-scope="scope">
            <div>{{ getActivityTypeName(scope.row.subType) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="activityName" label="活动名称" min-width="180">
        </el-table-column>
        <el-table-column prop="recordId" label="中奖ID" min-width="180">
        </el-table-column>
        <el-table-column label="中奖订单" width="160">
          <template slot-scope="{ row }">
            <div v-if="row.winOrders && row.winOrders.length > 0">
              <div v-for="(order, index) in row.winOrders" :key="index" style="margin-bottom: 5px;">
                <el-tooltip effect="light" placement="top-start">
                  <template slot="content">
                    <div class="order-info">
                      <div>订单号：{{ order.orderId || '-' }}</div>
                      <div>订单金额：{{ order.orderPayment ? order.orderPayment + '元' : '-' }}</div>
                      <div>订单状态：{{ order.orderStateRemark || '-' }}</div>
                    </div>
                  </template>
                  <span style="color: #3159ff; cursor: pointer;">{{ order.orderId || "-" }}</span>
                </el-tooltip>
              </div>
            </div>
            <div v-else>
              -
            </div>
          </template>
        </el-table-column>
        <el-table-column  prop="winOrderBelongShopNameStr" label="下单店铺" width="180">
          <template slot-scope="{ row }">
            {{ row.winOrderBelongShopNameStr || '-' }}
          </template>
        </el-table-column>
        <el-table-column  prop="orderPriceSum" label="订单金额" width="180"></el-table-column>
        <el-table-column prop="prizeTitle" label="奖品名称" min-width="180">
        </el-table-column>
        <el-table-column label="商品信息" min-width="300">
          <template slot-scope="scope">
            <div class="goodsInfo">
              <div class="goodsInfo_logo">
                <img :src="scope.row.logo" alt="" />
              </div>
              <template v-if="scope.row.isGoodManage != 1">
                <div class="goodsInfo_text" v-if="scope.row.skuId">
                  <a
                    :href="`http://item.jd.com/${scope.row.skuId}.html`"
                    target="_blank"
                    >{{ scope.row.skuName }}<br />
                    <span style="color: #666666"
                      >skuId:{{ scope.row.skuId }}</span
                    >
                  </a>
                </div>
                <div class="goodsInfo_text" v-else>
                  <div>{{ scope.row.skuName }}</div>
                </div>
              </template>
              <template v-else>
                <div class="goodsInfo_text" v-if="scope.row.assetsId">
                  <a @click="handleToGoods(scope.row.assetsId)" target="_blank"
                    >{{ scope.row.title }}<br />
                    <span style="color: #666666"
                      >id:{{ scope.row.assetsId }}</span
                    >
                  </a>
                </div>
                <div class="goodsInfo_text" v-else>
                  <div>{{ scope.row.title }}</div>
                </div>
              </template>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sendTime" label="中奖时间" min-width="180">
        </el-table-column>
        <el-table-column label="发货时间" min-width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.subType == 36 || scope.row.subType == 62">
              {{ scope.row.deliveryTime ? scope.row.deliveryTime : "-" }}
            </div>
            <div v-else>
              {{ scope.row.grantTime ? scope.row.grantTime : "-" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="prizeStatus" label="发放状态" min-width="120">
          <template slot-scope="scope">
            <jd-status v-if="scope.row.prizeStatus == -1" :status="2"
              >待领取</jd-status
            >
            <span v-else-if="scope.row.prizeStatus == 0">-</span>
            <jd-status v-else-if="scope.row.prizeStatus == 1" :status="4"
              >未中奖</jd-status
            >
            <jd-status v-else-if="scope.row.prizeStatus == 2" :status="2">
              待发放
            </jd-status>
            <jd-status v-else-if="scope.row.prizeStatus == 3" :status="0"
              >已发放</jd-status
            >
            <jd-status v-else-if="scope.row.prizeStatus == 4" :status="4"
              >发放失败</jd-status
            >
            <jd-status v-else-if="scope.row.prizeStatus == 5" :status="0"
              >已发放</jd-status
            >
            <jd-status v-else-if="scope.row.prizeStatus == 6" :status="0"
              >已发放</jd-status
            >
            <jd-status v-else-if="scope.row.prizeStatus == 7" :status="2"
              >待发放</jd-status
            >
            <jd-status v-else-if="scope.row.prizeStatus == 8" :status="4"
              >已失效</jd-status
            >
          </template>
        </el-table-column>
        <el-table-column label="发货状态" min-width="120">
          <template slot-scope="scope">
            <jd-status :status="scope.row.status == 5 ? 0 : 4">{{
              scope.row.status == 5 ? "已发货" : "未发货"
            }}</jd-status>
          </template>
        </el-table-column>
        <el-table-column prop="receiverName" label="收件人" min-width="120">
          <template slot-scope="scope">
            <div class="open">
              {{ scope.row.receiverName }}
              <!-- <div
                class="openHover"
                v-if="
                  scope.row.receiverName &&
                  scope.row.receiverName.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'receiverName',
                    'inkindTable',
                    scope.row,
                    scope.$index
                  )
                "
              >
                展开
              </div> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="receiverAddress"
          label="收件人地区"
          min-width="180"
        >
          <template slot-scope="scope">
            <div class="open">
              {{ scope.row.receiverAddress }}
              <!-- <div
                class="openHover"
                v-if="
                  scope.row.receiverAddress &&
                  scope.row.receiverAddress.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'receiverAddress',
                    'inkindTable',
                    scope.row,
                    scope.$index
                  )
                "
              >
                展开
              </div> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="detailedAddress"
          label="收件人详细地址"
          min-width="210"
        >
          <template slot-scope="scope">
            <div class="open">
              {{ scope.row.detailedAddress }}
              <!-- <div
                class="openHover"
                v-if="
                  scope.row.detailedAddress &&
                  scope.row.detailedAddress.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'detailedAddress',
                    'inkindTable',
                    scope.row,
                    scope.$index
                  )
                "
              >
                展开
              </div> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="recipientPhone" label="手机号码" min-width="120">
          <template slot-scope="scope">
            <div class="open">
              {{ scope.row.receiverMobile ? scope.row.receiverMobile : "-" }}
              <!-- <div
                class="openHover"
                v-if="
                  scope.row.receiverMobile &&
                  scope.row.receiverMobile.indexOf('*') != -1
                "
                @click="
                  handleDecrypt(
                    'receiverMobile',
                    'inkindTable',
                    scope.row,
                    scope.$index
                  )
                "
              >
                展开
              </div> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="billCode"
          label="快递单号"
          min-width="180"
        ></el-table-column>
        <el-table-column label="操作" width="260" fixed="right">
          <template slot-scope="scope">
            <jd-button
              type="blueText"
              v-if="scope.row.status == 2 || scope.row.status == 7"
              @click="changeShip(scope.row)"
              >标记发货</jd-button
            >
            <jd-button
              type="blueText"
              @click="cancelShip(scope.row)"
              v-else-if="scope.row.status == 5"
            >
              取消发货
            </jd-button>
            <jd-button
              type="blueText"
              style="margin-left: 8px"
              :disabled="!scope.row.id"
              @click="handleEnterCoutierNum(scope.row)"
              >录入快递单号</jd-button
            >
            <jd-button
              type="blueText"
              v-if="scope.row.status != 5 && scope.row.status != 8"
              @click="editAddress(scope.row)"
            >
              修改地址
            </jd-button>
          </template>
        </el-table-column>
      </jd-table>
    <!-- </div> -->

    <!-- 录入快递单号弹窗 -->
    <jd-dialog
      title="录入快递单号"
      width="420px"
      :visible.sync="enterCoutierNumShow"
      @close="blankEnterCoutierNum"
      :append-to-body="true"
      class="enter_coutier_num_dialog"
    >
      <el-form
        :model="enterCoutierFrom"
        label-width="86px"
        class="new-input-box"
      >
        <el-form-item label="快递单号：">
          <el-input
            placeholder=""
            v-model="enterCoutierNum"
            style="width: 250px"
            @keydown.native="clearInput"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <jd-button
          type="blue"
          style="margin-left: 8px"
          @click="enterCoutierSubmit"
          >确定</jd-button
        >
        <jd-button @click="blankEnterCoutierNum">取消</jd-button>
      </template>
    </jd-dialog>
    <!-- 批量标记发货弹窗 -->
    <jd-dialog
      title="批量发货"
      width="580px"
      :visible.sync="physicalBatchShipmentShow"
      @close="physicalBatchShipmentClose"
      :isShowSure="false"
      :isShowCancel="false"
      :append-to-body="true"
      class="physical_batch_shipment_dialog"
    >
      <el-form
        :model="physicalBatchShipmentFrom"
        label-width="120px"
        class="new-input-box"
      >
        <el-form-item label="上传文件：">
          <el-upload
            :before-upload="beforeUploadFile"
            :on-success="handleUpload"
            :show-file-list="false"
            class="upload-demo"
            :drag="true"
            multiple
            with-credentials
            :action="'/jd-hd-web/lockRight/markingSendStatusBatch/allActivities/fileUpload'"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label=" ">
          <jd-button type="blue" @click="handleDownloadTemplate"
            >下载模板</jd-button
          >
        </el-form-item>
        <el-form-item label=" " v-if="isShow">
          <p>
            导入成功{{ downloadResData.successNum || 0 }}条，导入失败{{
              downloadResData.failNum || 0
            }}条，导入失败相关用户昵称：
          </p>
          <div class="mlt12 download-box">
            <div
              class="downloaditem"
              v-for="(item, index) in downloadUserList"
              :key="index"
            >
              {{ index + 1 + ". " }}{{ item }}
            </div>
          </div>
        </el-form-item>
      </el-form>
    </jd-dialog>
    <!-- 生成人群 -->
    <crowdDialog
      :isShowCrowdDialog.sync="dialogTableVisible"
      :searchForm="formList"
      activityType="70"
      source="50"
      @close="dialogTableVisible = false"></crowdDialog>
      <generate
      :control="control"
      v-if="control"
      @transData="(val) => (control = val)"
      @transData1="getphone"
    ></generate>
    <jd-dialog
      title="修改收货信息"
      custom-class="system-dialog"
      :visible.sync="lockTakeGoodsVisible"
      width="520px"
      @close="lockTakeGoodsVisible = false"
    >
      <el-form
        :model="takeGoodsForm"
        ref="takeGoodsFormRef"
        label-width="120px"
        class="form-box new-input-box"
      >
        <el-form-item label="姓名：" prop="receiverName">
          <el-input
            v-model="takeGoodsForm.receiverName"
            placeholder="请输入..."
            style="width: 290px"
          ></el-input>
        </el-form-item>

        <el-form-item label="手机号码：" prop="receiverMobile">
          <el-input
            v-model="takeGoodsForm.receiverMobile"
            placeholder="请输入..."
            style="width: 290px"
          ></el-input>
        </el-form-item>

        <el-form-item label="地区：" prop="receiverAddress">
          <el-cascader
            v-model="takeGoodsForm.receiverAddress"
            :options="pcaTextArr"
            :placeholder="
              takeGoodsForm.receiverAddress.join('/') || '请选择地区'
            "
            style="width: 290px"
          ></el-cascader>
        </el-form-item>

        <el-form-item label="详细地址：" prop="detailedAddress">
          <el-input
            v-model="takeGoodsForm.detailedAddress"
            placeholder="请输入..."
            style="width: 290px"
          ></el-input>
        </el-form-item>
      </el-form>

      <template #footer>
        <jd-button type="blue" style="margin-left: 8px" @click="setTakeGoods"
          >确定</jd-button
        >
        <jd-button @click="lockTakeGoodsVisible = false">取消</jd-button>
      </template>
    </jd-dialog>
  </div>
</template>

<script>
import {
  signIssuance,
  getAllGoodsRecords,
  markingSendStatusLockRight,
  exportGiftList,
  writeReceiveAddress,
  updateReceiveAddress,
} from "@/api/jhk/integralCenter/PointActivityAnalyticController";
import selectActivity from "@/components/select-activity";
import crowdDialog from "@/views/interactiveMarketing/activity/crowd-Dialog.vue";
import generate from "@/components/generate_report.vue";
import { getShopList } from "@/api/public";
import { pcaTextArr } from "element-china-area-data";
import { useActivityTypeList} from "@/common/hook";
export default {
  name: "gift_list",
  props: {
    isShowPageTitle: {
      type: Boolean,
      default: true,
    },
    activityType: {
      type: [Number , String],
      default: '',
    }
  },
  components: {
    selectActivity,
    crowdDialog,
    generate
  },
  created() {
    if(this.activityType){
     this.activityObj.activityType = this.activityType;
    }
    if(this.activityType == 70){
      this.buriedPoint(1, "积分竞拍", "互动管理", "互动活动");
    }else{
      this.buriedPoint(1, "实物奖品名单", "互动管理", "互动活动");
    }
  },
  computed: {
    grayId() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'pin'
    },
    grayText() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'pin（加密）'
    },
    chaosParams() {
      return this.$store.getters.loginUserInfo.isGray ? 'chaosXid' : 'chaosPin'
    },
  },
  data() {
    return {
      control:false,
      dialogTableVisible: false,
      isShow: false,
      physicalBatchShipmentFrom: {},
      physicalBatchShipmentShow: false,
      // 控制录入快递单号弹窗
      enterCoutierNumShow: false,
      // 快递单号
      enterCoutierNum: "",
      // 弹窗表单标识
      enterCoutierFrom: {},
      // 录入快递单号当前行数据存储
      enterCoutierRowData: {},
      inputInkidNeedAwardList: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "发放状态：",
          prop: "prizeStatus",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "待发放", value: "2,7" },
            { label: "已发放", value: "3,5,6" },
            { label: "已失效", value: "8" },
          ],
        },
        {
          label: "发货状态：",
          prop: "status",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "未发货", value: "2,7,8,3" },
            { label: "已发货", value: "5" },
          ],
        },
        {
          label: "发货时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "grantStartTime",
          endKey: "grantEndTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "发放时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "选择活动：",
          prop: "active",
          slot: "active",
        },
        {
          label: "中奖时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "sendStartTime",
          endKey: "sendEndTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "下单店铺：",
          prop: "orderVenderId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            {
              label: "全部",
              value: "",
            }
          ],
        }
      ],
      // 实物奖品名单
      inkindTable: [],
      totalInkind: 0,
      formList: {
        pin: "",
        memberNick: "",
        activityIds: "",
        activitySubTypes: "",
        prizeStatus: "",
        status: "",
        grantStartTime: "",
        grantEndTime: "",
        startTime: "",
        endTime: "",
        sendStartTime: "",
        sendEndTime: "",
        orderVenderId: "",
        current: 1,
        size: 10,
      },
      loading: false,
      activityList: useActivityTypeList(),
      activityObj: {
        activityType: "",
        activityId: "",
      },
      physicalBatchShipmentShow: false,
      downloadResData: {
        successNum: 0,
        failNum: 0,
      },
      takeGoodsForm: {
        receiverName: "",
        receiverMobile: "",
        receiverAddress: [],
        detailedAddress: "",
      },
      lockTakeGoodsVisible: false,
      pcaTextArr,
    };
  },
  watch: {
    grayId: {
      handler(val) {
        // grayId 为 computed，data() 初始化时尚不可用；此处同步更新搜索表单标签
        this.inputInkidNeedAwardList.forEach(item => {
          if (item.prop == 'pin') {
            item.label = `用户${val}：`
            item.prop = val
          }
        })
      },
      immediate: true,
    },
  },
  mounted() {
    this.getList();
    this.getAllShopList();
  },
  methods: {
    setTakeGoods() {
      if (!this.takeGoodsForm.receiverName) {
        return this.$message.info("请输入姓名");
      } else if (!this.takeGoodsForm.receiverMobile) {
        return this.$message.info("请输入手机号码");
      } else if (this.takeGoodsForm.receiverAddress.length == 0) {
        return this.$message.info("请输入地区");
      } else if (!this.takeGoodsForm.detailedAddress) {
        return this.$message.info("请输入详细地址");
      }
      let postData = {};
      let reqAip = updateReceiveAddress;
      if(this.takeGoodsForm.isFillAddress == "未填写") {
        postData = {
          ...this.takeGoodsForm,
          province: this.takeGoodsForm.receiverAddress[0],
          city: this.takeGoodsForm.receiverAddress[1],
          district: this.takeGoodsForm.receiverAddress[2],
          receiverAddress: this.takeGoodsForm.receiverAddress.join("/"),
        }
        reqAip = writeReceiveAddress;
      } else {
        postData = {
          ...this.takeGoodsForm,
          province: this.takeGoodsForm.receiverAddress[0],
          city: this.takeGoodsForm.receiverAddress[1],
          district: this.takeGoodsForm.receiverAddress[2],
          receiverAddress: this.takeGoodsForm.receiverAddress.join("/"),
        };
      }
      delete postData.isFillAddress;
      reqAip(postData).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.$message.success("修改成功");
          this.lockTakeGoodsVisible = false;
          this.getList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    editAddress(row) {
      console.log(row);
      this.takeGoodsForm.id = row.id;
      this.takeGoodsForm.isFillAddress = row.isFillAddress;
      if(row.isFillAddress == "未填写") {
        this.takeGoodsForm.id = row.recordId;
        this.takeGoodsForm.receiverName = "";
        this.takeGoodsForm.receiverMobile = "";
        this.takeGoodsForm.detailedAddress = "";
        this.takeGoodsForm.receiverAddress = [];
        this.lockTakeGoodsVisible = true;
        return;
      }
      this.$decryptBatch
        .decrypt([
          row.decryptMemberNick || row.decryptReceiverName,
          row.decryptMobile || row.decryptReceiverMobile,
          row.decryptReceiverAddress,
          row.decryptDetailedAddress,
          row.encryptProvince,
          row.encryptCity,
          row.encryptDistrict,
        ])
        .then((res) => {
          if (res.code == 1) {
            let data = res.data;
            this.takeGoodsForm.receiverName = data[0];
            this.takeGoodsForm.receiverMobile = data[1];
            this.takeGoodsForm.detailedAddress = data[3];
            this.takeGoodsForm.receiverAddress = [data[4], data[5], data[6]];
            console.log(this.takeGoodsForm.receiverAddress);
            this.lockTakeGoodsVisible = true;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    getAllShopList() {
      getShopList().then(res=>{
        if(res.code == 1){
          const list = res.data.map((item)=>{
            return {
              label: item.shopTitle,
              value: item.venderId
            }
          })
          this.inputInkidNeedAwardList.forEach((item)=>{
            if(item.prop == 'orderVenderId') {
              item.options.push(...list)
            }
          })
        }
      }).catch((err)=>{
        console.error(err);
      })
    },
   getphone(val) {
      let param = this.formList.activityIds;
        const params = {
          activityIds: encodeURI(param),
          current: this.formList.current,
          size: this.formList.size,
          endTime: this.formList.endTime ? this.formList.endTime : "",
          startTime: this.formList.startTime ? this.formList.startTime : "",
          status: this.formList.status ? this.formList.status : "",
          memberNick: this.formList.memberNick ? this.formList.memberNick : "",
          activitySubTypes: this.formList.activitySubTypes ? this.formList.activitySubTypes : "",
          prizeStatus: this.formList.prizeStatus ? this.formList.prizeStatus : "",
          grantStartTime: this.formList.grantStartTime ? this.formList.grantStartTime : "",
          grantEndTime: this.formList.grantEndTime ? this.formList.grantEndTime : "",
          exportRemark:val || "",
          orderVenderId: this.formList.orderVenderId || "",
          sendStartTime: this.formList.sendStartTime || "",
          sendEndTime: this.formList.sendEndTime || "",
        };
        params[this.grayId] = this.formList[this.grayId] || "";
        exportGiftList(params).then((res) => {
          if (res.code == 1) {
            this.control = true;
          } else {
            this.$message.error(res.message);
          }
        });
    },
   async exportFn() {
      this.control= true;
    },
    // 点击解密  name: 修改的字段名   objdata：数组的名称, params:接口的参数  item：点击的对象    index：数组传下标值
    handleDecrypt(name, objdata, item, index) {
      let params =
        "decrypt" + name[0].toUpperCase() + name.substring(1, name.length);
      this.$decrypt
        .decryptJHK({ decryptContent: item[`${params}`] })
        .then((res) => {
          this[`${objdata}`][index][`${name}`] = res.message;
        });
    },
    resetForm(val) {
      this.formList.activityIds = "";
      if(this.activityType) {
        this.formList.activitySubTypes = this.activityType;
        this.$refs.selectActivityRef.resetActivityId();
      } else {
        this.formList.activitySubTypes = "";
        this.$refs.selectActivityRef.resetData();
      }
      this.formList[this.grayId] = "";
      this.formList.memberNick = "";
      this.formList.prizeStatus = "";
      this.formList.status = "";
      this.formList.grantStartTime = "";
      this.formList.grantEndTime = "";
      this.formList.startTime = "";
      this.formList.endTime = "";
      this.formList.orderVenderId = "";
      this.formList.sendStartTime = "";
      this.formList.sendEndTime = "";
      this.formList.current = 1;
      this.formList.size = 10;
      this.getList();
    },
    getList() {
      this.loading = true;
      if(this.activityType){
        this.formList.activitySubTypes = this.activityType;
      }
      getAllGoodsRecords(this.formList)
        .then((res) => {
          this.loading = false;
          if (res.code == 1) {
            this.inkindTable = res.data.records || [];
            this.totalInkind = res.data.total || 0;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleDownloadTemplate() {
      let url =
        "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/%E6%89%B9%E9%87%8F%E5%8F%91%E8%B4%A7%E6%A8%A1%E6%9D%BF2.xlsx";
      let fileName = "实物奖品名单批量发货模板.xlsx";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      elem.setAttribute("download", fileName);
      document.body.appendChild(elem);
      elem.click();
    },
    // 上传文件回调
    handleUpload(res) {
      this.isShow = true;
      // 上传文件
      if (res.code == 0) {
        this.$message.error(res.message);
      } else if (res.code == 1) {
        this.downloadResData = res.data;
        this.downloadUserList = res.data.failUserName;
        this.getList();
      }
    },
    // 上传文件处理
    beforeUploadFile(file) {
      console.log(file, "5433");
      if (
        file.type !=
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        file.type != "application/vnd.ms-excel" &&
        file.type != "text/csv"
      ) {
        this.$message.warning("请上传正确格式的文件");
        return false;
      }
    },
    physicalBatchShipmentClose() {
      this.physicalBatchShipmentShow = false;
      this.downloadResData = {};
      this.downloadUserList = [];
    },
    markIss(row) {
      signIssuance({ id: row.recordId || row.id }).then((res) => {
        if (res && res.code == 1) {
          this.$message.success(res.message);
          this.getList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //标记发货
    changeShip(row) {
      this.$confirm("是否标记为发货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
        customClass: "reverse-buttons",
      }).then(() => {
        this.markIss(row);
      });
    },
    // 取消发货
    cancelShip(row) {
      this.$confirm("是否取消发货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
        customClass: "reverse-buttons",
      }).then(() => {
        this.markIss(row);
      });
    },
    // 监听录入快递单号按钮
    handleEnterCoutierNum(row) {
      this.enterCoutierNum = row.billCode;
      this.enterCoutierRowData = row;
      this.$forceUpdate();
      // 打开弹窗
      this.enterCoutierNumShow = true;
    },
    // 置空录入快递单号输入框并关闭弹窗
    blankEnterCoutierNum() {
      this.enterCoutierNum = "";
      // 清除当前行存储数据
      this.enterCoutierRowData = {};
      this.enterCoutierNumShow = false;
      this.sendOutGoodsShow = false;
    },
    clearInput(e) {
      let key = e.key;
      if (key === "e" || key === "E" || key === "+" || key === "-") {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    // 录入快递单号提交
    enterCoutierSubmit() {
      let params = {
        billCode: this.enterCoutierNum,
        isUpdatePrizeStatus: true,
        id: this.enterCoutierRowData.id,
      };
      markingSendStatusLockRight(params)
        .then((res) => {
          if (res.code == 1) {
            this.getList();
            this.blankEnterCoutierNum();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.$message.error("录入快递单号失败");
        });
    },
    // 实物奖品搜索
    searchInkind(val) {
      this.formList.activitySubTypes = this.activityObj.activityType;
      this.formList.activityIds = this.activityObj.activityId;
      this.formList.status = val.status;
      this.formList.prizeStatus = val.prizeStatus;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.grantStartTime = val.grantStartTime;
      this.formList.grantEndTime = val.grantEndTime;
      this.formList[this.grayId] = val[this.grayId];
      this.formList.memberNick = val.memberNick;
      this.formList.orderVenderId = val.orderVenderId || "";
      this.formList.sendStartTime = val.sendStartTime;
      this.formList.sendEndTime = val.sendEndTime;
      this.formList.current = 1;
      this.getList();
    },
    // 分页处理
    handlePageInkind(page) {
      this.formList.current = page.pageNum;
      this.formList.size = page.pageSize;
      this.getList();
    },
    // 批量标记发货
    batchMarkForShipment() {
      // 批量标记发货逻辑
      this.physicalBatchShipmentShow = true;
    },
    // 跳转到商品管理
    handleToGoods(id) {
      let routeUrl = this.$router.resolve({
        path: "/tool/prizeCenter/goodsManagement",
        query: {
          id,
          tabActive: 1,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.pages {
  background-color: #fff;
  padding: 16px;
  height: 100%;
  border-radius: 8px;
  // .pages-content {
  //   height: 100%;
  //   background: #ffffff;
  //   border-radius: 16px 16px 0 0;
  //   padding: 0 20px;
  //   overflow: hidden;
  //   padding: 20px;
    .goodsInfo {
      padding: 5px 0;
      display: flex;
      align-items: center;
      &_logo {
        display: flex;
        width: 80px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          width: 70px;
          border-radius: 4px;
        }
      }
      &_text {
        flex: 1;
        color: #666666;
        cursor: pointer;
        margin-left: 5px;
        a {
          color: #666666;
          margin-top: 5px;
        }
      }
    }
    .physical_batch_shipment_dialog {
      .upload-demo {
        /deep/ .el-upload .el-upload-dragger {
          width: 250px;
        }
      }
      .download_template_box {
        position: absolute;
        right: 24px;
        top: 17%;
      }
      .downloadMsgBox {
        width: 100%;
        min-height: 100px;
      }
      .physical_batch_shipment_dialog_floor {
        text-align: right;
        width: 100%;
      }
    }
  //   // 表格列过多时，空状态缺省图固定在可视区域中央
  //   /deep/ .el-table__empty-block {
  //     width: auto !important;
  //     position: sticky;
  //     left: 50%;
  //     transform: translateX(-50%);
  //   }
  //   //  为右侧固定列添加更高的z-index，确保操作列显示在其他列上方
  //    /deep/ .el-table__fixed-right {
  //       z-index: 99;
  //     }
  // // }
    //  为右侧固定列添加更高的z-index，确保操作列显示在其他列上方
  /deep/ .el-table__header {
    background-color: #fff;
  }

  /deep/ tr.el-table__row {
    /* 解决横向滚动文字穿透的问题 */
    &.el-table__row--striped {
      .el-table__cell {
        background-color: #fff !important;
      }
    }
    &:not(.el-table__row--striped) {
      background-color: #fff !important;
    }
  }
  // 为右侧固定列添加更高的z-index，确保固定列显示在其他列上方
  /deep/ .el-table__fixed-right {
    z-index: 99;
    background: #fff;
  }

  // 确保右侧固定列表头背景不透明
  /deep/ .el-table__fixed-right .el-table__header-wrapper {
    background: #f3f5f7;
  }

  // 确保右侧固定列表体背景不透明
  /deep/ .el-table__fixed-right .el-table__fixed-body-wrapper {
    background: #fff;
  }
  .mlt12 {
    margin-left: 24px;
  }
  .download-box {
    max-height: 300px;
    overflow-y: auto;
  }
  .downloaditem {
    line-height: 24px;
  }
}
.order-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
}
</style>
